// @ts-nocheck
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";

import React, { useEffect } from "react";

import Header from "./components/Header";
import FormEdit from "./scenes/formedit";
import FormExample from "./scenes/formexample";
import FormSettings from "./scenes/formsettings";
import { CssBaseline } from "@mui/material";
import ElementEdit from "./scenes/elementedit";
import axios from "axios";
import { URL } from "./service/Service";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Login from "./scenes/loginpage";
import RegisterPage from "./scenes/registerpage";
import NotFound from "./scenes/notfound";
import ElementPicker from "./components/formElements/ElementPicker";
import Forms from "./scenes/forms";
import FormReader from "./scenes/formreader";
import Replies from "./scenes/replies";
import AdminDashboard from "./scenes/admindashboard";
import AdminForms from "./scenes/adminforms";
import AdminReplies from "./scenes/adminreplies";
import AdminUsers from "./scenes/adminusers";
import AdminRegisterPage from "./scenes/adminregisterpage";
import UserPage from "./scenes/user";
import FormWizard1 from "./scenes/formwizard/index1";
import FormWizard2 from "./scenes/formwizard/index2";
import FormWizard3 from "./scenes/formwizard/index3";
import ElementEditorWizard from "./scenes/elementeditwizard";
import IndexLanding from "./scenes/landingpage/indexlanding";
import ResetPassword from "./scenes/resetpassword";
import ResetPasswordForm from "./scenes/resetpasswordform";
import FormSuccess from "./scenes/formsuccess";
import CompanyDashboard from "./scenes/companydashboard";
import UserDashboard from "./scenes/userdashboard";
import CompanyUsers from "./scenes/companyusers";
import Products from "./scenes/products";
import AdminCatalogs from "./scenes/admincatalogs";
import Storefront from "./scenes/storefront";
import Orders from "./scenes/orders";
import Support from "./scenes/support";
import StoreDashboard from "./scenes/storedashboard";
import Shipping from "./scenes/shipping";
import RoleRoute from "./components/RoleRoute";
import LanguageSelector from "./components/LanguageSelector";
import { useI18n } from "./i18n/I18nContext";
import { STORE_ENABLED } from "./config/features";

const theme = createTheme({
  palette: {
    primary: {
      main: "#031E1B",
    },

    secondary: {
      main: "#FFFFFF",
    },

    background: {
      default: "#FFFFFF",
    },
  },

  typography: {
    fontFamily: [].join(","),
  },
});

function App() {
  const location = useLocation();

  const token = sessionStorage.getItem("jwt");

  const history = useNavigate();

  const { resetToPreference } = useI18n();

  /*
   * Rotas públicas.
   *
   * Estas páginas podem ser abertas sem autenticação.
   */
  const isPublicRoute =
    location.pathname === "/" ||
    location.pathname === "/login" ||
    location.pathname === "/register" ||
    location.pathname.startsWith("/resetpassword") ||
    location.pathname.startsWith("/clientforms") ||
    (STORE_ENABLED && location.pathname.startsWith("/shop/"));

  /*
   * Wrapper para rotas protegidas por role.
   */
  const forRoles = (roles, element) => (
    <RoleRoute allow={roles}>{element}</RoleRoute>
  );

  /*
   * Seletor standalone de idioma.
   *
   * IMPORTANTE:
   *
   * NÃO aparece na landing "/"
   * porque o IndexLanding já possui o seu
   * próprio LanguageSelector dentro do menu.
   *
   * Aparece em:
   *
   * /login
   * /register
   * /resetpassword
   * /resetpassword/:token
   */
  const showStandaloneLanguageSelector =
    !location.pathname.startsWith("/clientforms/") &&
    (location.pathname === "/login" ||
      location.pathname === "/register" ||
      location.pathname.startsWith("/resetpassword"));

  /*
   * O formulário público pode alterar temporariamente
   * o idioma ativo.
   *
   * Quando saímos dos formulários públicos,
   * recuperamos a preferência selecionada
   * pelo utilizador do backoffice.
   */
  useEffect(() => {
    if (!location.pathname.startsWith("/clientforms/")) {
      resetToPreference();
    }
  }, [location.pathname, resetToPreference]);

  /*
   * Validação do token.
   *
   * As páginas públicas continuam acessíveis
   * mesmo que exista um token expirado
   * no sessionStorage.
   */
  useEffect(() => {
    if (isPublicRoute) {
      return;
    }

    if (!token) {
      history("/login", {
        replace: true,
      });

      return;
    }

    let active = true;

    axios
      .get(`${URL}/api/validate`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .catch(() => {
        if (!active) {
          return;
        }

        sessionStorage.removeItem("jwt");

        history("/login", {
          replace: true,
        });
      });

    return () => {
      active = false;
    };
  }, [token, history, isPublicRoute]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <div className="app">
        {/*
         * SELETOR DE IDIOMA
         *
         * Login
         * Registo
         * Reset password
         *
         * A landing NÃO entra aqui.
         */}
        {showStandaloneLanguageSelector && (
          <div className="fixed right-8 top-5 z-[1000]">
            <LanguageSelector compact />
          </div>
        )}

        <main
          className={
            location.pathname.startsWith("/clientforms/")
              ? "public-form-workspace w-full min-h-screen"
              : location.pathname === "/" ||
                  location.pathname === "/login" ||
                  location.pathname === "/register" ||
                  location.pathname.startsWith("/resetpassword")
                ? "w-full min-h-screen"
                : "app-workspace w-full min-h-screen"
          }
        >
          {/*
           * HEADER DO BACKOFFICE
           *
           * Não aparece nas páginas públicas.
           */}
          {location.pathname !== "/login" &&
            location.pathname !== "/" &&
            location.pathname !== "/register" &&
            !location.pathname.startsWith("/clientforms/") &&
            !location.pathname.startsWith("/shop/") &&
            location.pathname !== "/resetpassword" &&
            !location.pathname.startsWith("/resetpassword/") && <Header />}

          <Routes>
            {/* NOT FOUND */}
            <Route path="*" element={<NotFound />} />

            {/* FORMULÁRIO PÚBLICO */}
            <Route path="/clientforms/:idform" element={<FormReader />} />

            {STORE_ENABLED && <Route path="/shop/:storeSlug" element={<Storefront />} />}

            {/* LANDING PAGE */}
            <Route path="/" element={<IndexLanding />} />

            {/* SUCESSO DO FORMULÁRIO / PAGAMENTO */}
            <Route
              path="/clientforms/success/:method/"
              element={<FormSuccess />}
            />

            {/* FORM SETTINGS */}
            <Route
              path="/forms/:idform/editform"
              element={forRoles(["USER", "COMPANY"], <FormSettings />)}
            />

            {/* FORM EDITOR */}
            <Route
              path="/forms/:idform/formeditor"
              element={forRoles(["USER", "COMPANY"], <FormEdit />)}
            />

            {/* REPLIES */}
            <Route
              path="/forms/:idform/replies"
              element={forRoles(["USER", "COMPANY"], <Replies />)}
            />

            {/* EDITAR ELEMENTO */}
            <Route
              path="/forms/:idform/formelements/:idformelement/edit"
              element={forRoles(["USER", "COMPANY"], <ElementEdit />)}
            />

            {/* ELEMENT WIZARD */}
            <Route
              path="/forms/:idform/formelements/:idformelement/wizard"
              element={forRoles(["USER", "COMPANY"], <ElementEditorWizard />)}
            />

            {/* FORM LIST */}
            <Route
              path="/forms"
              element={forRoles(["USER", "COMPANY"], <Forms />)}
            />

            {/* COMPANY DASHBOARD */}
            <Route
              path="/company/dashboard"
              element={forRoles(["COMPANY"], <CompanyDashboard />)}
            />

            {/* USER DASHBOARD */}
            <Route
              path="/dashboard"
              element={forRoles(["USER"], <UserDashboard />)}
            />

            {/* COMPANY USERS */}
            <Route
              path="/company/users"
              element={forRoles(["COMPANY"], <CompanyUsers />)}
            />

            {/* PRODUCT CATALOG */}
            {STORE_ENABLED && <Route path="/store" element={forRoles(["USER", "COMPANY"], <StoreDashboard />)} />}
            {STORE_ENABLED && <Route path="/store/shipping" element={forRoles(["COMPANY"], <Shipping />)} />}
            {STORE_ENABLED && <Route path="/products" element={forRoles(["USER", "COMPANY"], <Products />)} />}
            {STORE_ENABLED && <Route path="/orders" element={forRoles(["USER", "COMPANY"], <Orders />)} />}
            <Route
              path="/support"
              element={forRoles(["USER", "COMPANY", "ADMIN"], <Support />)}
            />

            {/* ADMIN DASHBOARD */}
            {STORE_ENABLED && <Route path="/admin/store" element={forRoles(["ADMIN"], <StoreDashboard />)} />}
            {STORE_ENABLED && <Route path="/admin/catalogs" element={forRoles(["ADMIN"], <AdminCatalogs />)} />}
            {STORE_ENABLED && <Route path="/admin/orders" element={forRoles(["ADMIN"], <Orders admin />)} />}

            <Route
              path="/admin/dashboard"
              element={forRoles(["ADMIN"], <AdminDashboard />)}
            />

            {/* FORM EXAMPLE */}
            <Route
              path="/formexample"
              element={forRoles(["USER", "COMPANY"], <FormExample />)}
            />

            {/* LOGIN */}
            <Route path="/login" element={<Login />} />

            {/* REGISTER */}
            <Route path="/register" element={<RegisterPage />} />

            {/* RESET PASSWORD */}
            <Route path="/resetpassword" element={<ResetPassword />} />

            {/* RESET PASSWORD COM TOKEN */}
            <Route
              path="/resetpassword/:token"
              element={<ResetPasswordForm />}
            />

            {/* ELEMENT PICKER */}
            <Route
              path="/elementpicker"
              element={forRoles(["USER", "COMPANY"], <ElementPicker />)}
            />

            {/* ADMIN FORMS */}
            <Route
              path="/admin/forms"
              element={forRoles(["ADMIN"], <AdminForms />)}
            />

            {/* ADMIN FORM REPLIES */}
            <Route
              path="/admin/forms/:idform/replies"
              element={forRoles(["ADMIN"], <AdminReplies />)}
            />

            {/* ADMIN USERS */}
            <Route
              path="/admin/users"
              element={forRoles(["ADMIN"], <AdminUsers />)}
            />

            {/* ADMIN REGISTER */}
            <Route
              path="/adminregisterpage"
              element={forRoles(["ADMIN"], <AdminRegisterPage />)}
            />

            {/* USER */}
            <Route
              path="/user"
              element={forRoles(["USER", "COMPANY"], <UserPage />)}
            />

            {/* FORM WIZARD 1 */}
            <Route
              path="/forms/:idform/formwizard/1"
              element={forRoles(["USER", "COMPANY"], <FormWizard1 />)}
            />

            {/* FORM WIZARD 2 */}
            <Route
              path="/forms/:idform/formwizard/2"
              element={forRoles(["USER", "COMPANY"], <FormWizard2 />)}
            />

            {/* FORM WIZARD 3 */}
            <Route
              path="/forms/:idform/formwizard/3"
              element={forRoles(["USER", "COMPANY"], <FormWizard3 />)}
            />

            {/* ADMIN FORM WIZARD 1 */}
            <Route
              path="/admin/forms/:idform/formwizard/1"
              element={forRoles(["ADMIN"], <FormWizard1 />)}
            />

            {/* ADMIN FORM WIZARD 2 */}
            <Route
              path="/admin/forms/:idform/formwizard/2"
              element={forRoles(["ADMIN"], <FormWizard2 />)}
            />

            {/* ADMIN FORM WIZARD 3 */}
            <Route
              path="/admin/forms/:idform/formwizard/3"
              element={forRoles(["ADMIN"], <FormWizard3 />)}
            />

            {/* ADMIN USER */}
            <Route
              path="/admin/user/"
              element={forRoles(["ADMIN"], <UserPage />)}
            />

            {/* ADMIN ELEMENT WIZARD */}
            <Route
              path="/admin/forms/:idform/formelements/:idformelement/wizard"
              element={forRoles(["ADMIN"], <ElementEditorWizard />)}
            />
          </Routes>
        </main>
      </div>
    </ThemeProvider>
  );
}

export default App;
